/**
 * Customer view of the client statement (CUSTOMER-STATEMENT.md §3–§6, backend CSB1-CSB4): invoices against the money
 * the customer paid, with each invoice's status. `GET /api/reports/client-ledger/{orgId}?view=customer`.
 */

import ApiService from '../api.service';
import { keysSnakeToCamel } from '../../utils/apiConvert';

export const customerStatementService = {
  // params: { from, to, lineage } → { organization, period, summary, lines[], note }
  getStatement: async (orgId, params = {}) =>
    keysSnakeToCamel((await ApiService.get(`/api/reports/client-ledger/${orgId}`, { params: { ...params, view: 'customer' } })).data?.data),
};

export default customerStatementService;
